import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'
import api from '../api'
import useDataLoader from '../dataLoader'

const useReplaceManualQueryDocumentRows = (organizationId: number | null) => {
  const token = useSelector(selectToken)
  const replaceRows = async (documentId: number, rows: { query: string; country: string }[]) => {
    if (organizationId) {
      try {
        return await api.replaceManualQueryDocumentRows({ token, organizationId, documentId, rows })
      } catch (error: any) {
        const rowErrors = error?.response?.data?.detail?.errors
        if (Array.isArray(rowErrors) && rowErrors.length > 0) {
          throw new Error(rowErrors.join(' '))
        }
        throw error
      }
    }
  }

  return useDataLoader(replaceRows, [], null)
}

export default useReplaceManualQueryDocumentRows
